/**
 * Start swiper instances
 */

import Swiper from 'swiper/dist/js/swiper.min';

export const initSwiper = function(md){

    let speed = 1000;
    if($(".image-slider .swiper-slide").length > 2 ) {

        let bannerSwiperOverlay = new Swiper(".swiper-container--overlay", {
            slidesPerView: 1,
            spaceBetween: 0,
            direction: 'horizontal',
            speed: speed,
            loop: true,
            keyboardControl: true,
            autoplay: {
                delay: 5000
            },
            effect: 'fade',
            navigation: {
                nextEl: '.image-slider__nav-button--next',
                prevEl: '.image-slider__nav-button--prev',
            },

            by: 'container',


            pagination: {
                el: '.image-slider__swiper-paging',
                type: 'bullets',
                clickable: true,
                renderBullet: function paginationBulletRender(index, className) {
                    index = index+1;
                    if( index < 10 ){
                        index = '0'+index;
                    }
                    return '<button class="'+className+'">' + index + '</button>';
                },

            },

        });

        bannerSwiperOverlay.autoplay.start();

    }


};




